import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgApexchartsModule } from 'ng-apexcharts';
import { FormatChatPipe } from '../../../pipes/format-chat/format-chat.pipe';

@Component({
  selector: 'app-block-elements',
  imports: [
    NgApexchartsModule,
    FormatChatPipe
  ],
  templateUrl: './block-elements.component.html',
  styleUrl: './block-elements.component.scss'
})
export class BlockElementsComponent implements OnChanges {
  @Input() contentBlocks: any[] | undefined = [];
  @Input() loading: any = false;
  chartColors: string[] = ['#2E3D30', '#6B4E31', '#5C7156', '#8A9A7F'];
  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.contentBlocks && Array.isArray(this.contentBlocks)) {
      this.contentBlocks.forEach((block) => {
        if (
          Array.isArray(block.items) &&                  // ✅ items is an array
          block.items.length > 0 &&                      // ✅ array is not empty
          typeof block.items[0] === 'object' &&          // ✅ first item is an object
          !Array.isArray(block.items[0])                 // 🚫 not a nested array
        ) {
          block.type = 'Tee_Time_list'; // Change type for array of objects
        }
        // Else leave as-is (Markdown or string array)
      });
    }
  }
  
}
